import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { RouterLink } from '@/common/components/RouterLink/RouterLink';
import { Flex, Heading, Text } from '@coverflex-tech/hypernova';
import { Href } from 'expo-router';

interface IProps {
  title?: string;
  children: ReactNode;
  className?: string;
  seeAllRoute?: string;
  onClick?: () => void;
}

export const ListSection = ({
  title,
  children,
  className,
  seeAllRoute,
  onClick,
}: IProps) => {
  const { t } = useTranslation();
  return (
    <Flex flexDirection="column" gap="md" className={className}>
      {title && (
        <Flex alignItems="center" gap="md" justifyContent="space-between">
          <Heading level={4}>{title}</Heading>
          {seeAllRoute ? (
            <RouterLink onPress={onClick} href={seeAllRoute as Href}>
              <Text size="sm" bold underline>
                {t('general.see_all')}
              </Text>
            </RouterLink>
          ) : null}
        </Flex>
      )}
      {children}
    </Flex>
  );
};
